import * as React from "react";
import Image from "../../../ui/widgets/image";
import Button from "../../../ui/widgets/button";
import Typography from "../../../ui/widgets/typography";
import IconDrop from "../../../resources/images/scd-upload-drag-drop.svg";
import { useMessageSource } from "react-message-source";
import { MouseEventHandler, useContext } from "react";
import { AttachmentUploadContext } from "../adapter";
import { UploadHelper } from "../upload-helper";
import { ScopedLoadingOverlay } from "../../../ui/widgets/loader";

interface EmptyUploaderProps {
  handleOnClickFileUploader: MouseEventHandler;
  isDropActive: boolean;
  isUploadInProgress: boolean;
}

const classNameBase = "scd-upload";

const EmptyUploader: React.FC<EmptyUploaderProps> = ({
  handleOnClickFileUploader,
  isDropActive,
  isUploadInProgress,
}: EmptyUploaderProps) => {
  const { getMessage } = useMessageSource();

  const { maxFileSize } = useContext(AttachmentUploadContext);

  return (
    <>
      <ScopedLoadingOverlay loading={isUploadInProgress}>
        <div className={`${classNameBase}-image`}>
          <Image src={IconDrop} />
        </div>
      </ScopedLoadingOverlay>
      <div className={`${classNameBase}-file-wrapper`}>
        <Button
          onClick={handleOnClickFileUploader}
          disabled={isDropActive || isUploadInProgress}
        >
          {getMessage("Button.upload")}
        </Button>
        <Typography variant="body2" className={`${classNameBase}-file-name`}>
          {getMessage(
            "DocumentUpload.Uploader.max-file-size.text",
            `${UploadHelper.calculateFileSizeInMB(maxFileSize)} MB`,
          )}
        </Typography>
      </div>
    </>
  );
};

export default EmptyUploader;
